const STORAGE_KEY = "styx_v1_last_topic_by_workspace";

type TopicByWorkspaceMap = Record<string, string>;

function readMap(): TopicByWorkspaceMap {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return {};
    const parsed = JSON.parse(raw) as unknown;
    if (!parsed || typeof parsed !== "object" || Array.isArray(parsed)) return {};
    return parsed as TopicByWorkspaceMap;
  } catch {
    return {};
  }
}

function writeMap(map: TopicByWorkspaceMap): void {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(map));
  } catch {
    /* ignore quota / private mode */
  }
}

/** Последний открытый topic в workspace (если id ещё валиден — выбрать его при входе). */
export function getLastTopicIdForWorkspace(workspaceId: string): string | null {
  const id = readMap()[workspaceId];
  return typeof id === "string" && id.length > 0 ? id : null;
}

export function rememberWorkspaceTopic(workspaceId: string, topicId: string): void {
  if (!workspaceId || !topicId) return;
  const map = readMap();
  map[workspaceId] = topicId;
  writeMap(map);
}
